import { SearchAddressResponse } from '@/types/service-response'

export class SearchAddress {
  public constructor (
    readonly id: number,
    readonly agencyName: string,
    readonly adressNummer: string,
    readonly sortierung: string,
    readonly name: string,
    readonly vorname: string,
    readonly sperrung: string,
    readonly strasse: string,
    readonly hausnummer: string,
    readonly land: string,
    readonly plz: string,
    readonly ort: string,
    readonly region: string,
    readonly adressGruppe: string,
    readonly zusatz: string,
    readonly telefonPrivate: string,
    readonly telefonGeschaftlich: string,
    readonly mailPrivat: string,
    readonly mailGeschaeftlich: string,
    readonly genAdresse: string
  ) {}

  static createFromResponse (responseData: SearchAddressResponse[]): Array<SearchAddress> {
    return responseData.map((item: SearchAddressResponse ) => {
      return new SearchAddress(
        item.ID,
        item.AgencyName ? item.AgencyName : '',
        item.AdressNummer ? item.AdressNummer : '',
        item.Sortierung ? item.Sortierung : '',
        item.Name ? item.Name : '',
        item.Vorname ? item.Vorname : '',
        item.Sperrung ? item.Sperrung : '',
        item.Strasse ? item.Strasse : '',
        item.Hausnummer ? item.Hausnummer : '',
        item.Land ? item.Land : '',
        item.PLZ ? item.PLZ : '',
        item.Ort ? item.Ort : '',
        item.Region ? item.Region : '',
        item.AdressGruppe ? item.AdressGruppe : '',
        item.Zusatz ? item.Zusatz : '',
        item.TelefonPrivat ? item.TelefonPrivat : '',
        item.TelefonGeschaeftlich ? item.TelefonGeschaeftlich : '',
          item.MailPrivat ? item.MailPrivat : '',
        item.MailGeschaeftlich ? item.MailGeschaeftlich : '',
        item.GenAdresse ? item.GenAdresse : ''
      )
    })
  }
}
